import { backend } from 'modules/data';

export const countryCodesWhitelist = [backend.CountryCode.GB];
